module.exports = __webpack_public_path__ + "img/eggsport.4674d009.gif";